import HeaderContents from './HeaderContents'
import ProductNameHeader from './ProductNameHeader'

const Header = () => {
  return (
    <div className="switcher:last-center">
      <ProductNameHeader />
      <HeaderContents />
    </div>
  )
}

export default Header
